import getFreshSideObject from "./getFreshSideObject.js";
export default function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
// module id = 964
// module chunks = 115